<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-chart-line"></i> Relatórios - CRM</h3>
      </div>
    </div>
    <!-- <NxDataGrid :load="load">
      <NxDataGridColumn field="protocolo" title="PROTOCOLO"/>
      <NxDataGridColumn field="pessoaDocument" title="CPF/CNPJ"/>
      <NxDataGridColumn field="pessoaNome" title="NOME"/>
      <NxDataGridColumn field="quadroNome" title="QUADRO">
        <NxDataGridItem>
          <template #default="{ item }">
            teste: {{ item.protocolo }}
          </template>
        </NxDataGridItem>
      </NxDataGridColumn>
      <NxDataGridColumn field="quadroColunaNome" title="COLUNA" :sortable="false" />
    </NxDataGrid> -->

    <Tables ref="tableGrid"
            :columns="columns"
            :showSearch="true"
            :showReload="false"
            :showTipFooter="false"
            v-on:Search="onShowSearch"
            v-on:Load="onLoad"
            v-on:Reload="onLoad">
      <template slot="table-header-buttons">
        <a href="javascript:void(0);" v-b-tooltip.hover :title="'Exportar'" @click="showConfirmationModal">
          <i class="fas fa-file-excel text-third" style="font-size: 15px"></i>
        </a>
        <a href="javascript:void(0);" id="popover-report-collumn">
          <i class="fas fa-columns text-third" style="font-size: 15px"></i>
        </a>
        <b-popover target="popover-report-collumn" triggers="hover" placement="bottomleft">
          <template #title>Adicionar/ Remover Colunas</template>
          <div class="pb-3">
            <div class="pb-3" style="font-size:9px">
              Clique para adicionar/ remover colunas na grid
            </div>
            <div class="pl-4" >
              <div v-for="(item,index) in columnsOpt" :key="index">
                <b-form-checkbox v-model="item.value" name="check-button" switch @change="setVisibleColumns">
                  {{item.label}}
                </b-form-checkbox>
              </div>
            </div>
          </div>
        </b-popover>
      </template>
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <template>
          <TableColumn v-if="columnsOpt[0].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.protocolo ? obj.protocolo : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[1].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.pessoaDocument ? onFormatDocument(obj.pessoaDocument.toString()) : ' '" />
          <TableColumn v-if="columnsOpt[2].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.pessoaNome ? obj.pessoaNome.toUpperCase() : ' '" />
          <TableColumn v-if="columnsOpt[3].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.nomePa ? obj.nomePa.toUpperCase() : '-'" />
          <TableColumn v-if="columnsOpt[4].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.nomeGerente ? obj.nomeGerente.toUpperCase() : '-'" />
          <TableColumn v-if="columnsOpt[5].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.agenteRelacionamento ? obj.agenteRelacionamento.toUpperCase() : '-'" />
          <TableColumn v-if="columnsOpt[6].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.quadroNome ? obj.quadroNome : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[7].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.quadroColunaNome ? obj.quadroColunaNome : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[8].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.origemNome ? obj.origemNome : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[9].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.responsaveis ? obj.responsaveis : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[10].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.produtoNome ? obj.produtoNome : '-'" />
          <TableColumn v-if="columnsOpt[11].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.produtoValor ? obj.produtoValor.toString() : 'R$ 0,00'" />
          <TableColumn v-if="columnsOpt[12].value" :IsText="true" v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.dataCriacao ? formatDateAndTime(obj.dataCriacao) : ''" />
          <TableColumn v-if="columnsOpt[13].value" :IsCustom="true" :status="obj.inative ? 0 : 1">
            <a href="javascript:void(0);" @click="openCard(obj.cardId)">
              {{ obj.dataFimSituacao ? moment(new Date(obj.dataFimSituacao)).format('DD/MM/YYYY') : 'NÃO POSSUI' }}
            </a>
          </TableColumn>
          <TableColumn v-if="columnsOpt[14].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.situacao ? obj.situacao : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[15].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.motivo ? obj.motivo : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[16].value" :IsCustom="true" :status="obj.inative ? 0 : 1">
            <a href="javascript:void(0);" @click="openCard(obj.cardId)">
              {{ obj.agendamento ? moment(new Date(obj.agendamento)).format('DD/MM/YYYY') : 'NÃO POSSUI' }}
            </a>
          </TableColumn>
          <TableColumn v-if="columnsOpt[17].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.diasAberto ? obj.diasAberto.toString() : ' '" />
          <TableColumn v-if="columnsOpt[18].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.usuarioCriador ? obj.usuarioCriador : ' '" />
        </template>
      </tr>
    </Tables>
    <ModalCard ref="ModalCard" v-if="selectedCard" :boardColumns="[]" @hideModal="closeCard" :key="selectedCard"
    :cardId="selectedCard" />
    <SidebarSearch @search="onSearch" />
    <AddConfirmation
      ref="confirmation-modal"
      :saveFunction="onExportExcel"
      :warnText="'Deseja extrair o relatório em arquivo Excel?'"
    />
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { loading } from '@/shared/utils/UIHelper'
import ReportCrmRepository from '@/shared/http/repositories/crm/reportcrm.js'
import PARepository from '@/shared/http/repositories/configurations/pa.js'
import ModalCard from '@/views/private/crm/components/modalCard/modalCard.vue'

import { NxDataGrid, NxDataGridColumn, NxDataGridItem } from '@/components/nexum/components'
import SidebarSearch from '@/views/private/reports/crm/search/SidebarRelatorioCrm.vue'
import AddConfirmation from '@/components/UI/confirmation/addConfirmation.vue'
import {CookieUtils} from '../../../../shared/utils/cookiesUtils'
import {toast} from '../../../../shared/utils/UIHelper'

export default {
  name: 'ReportCrm',
  mixins: [ActionsForm],
  data () {
    return {
      data: null,
      form: null,
      filters: {
        'document': null,
        'nome': null,
        'numeroPA': null,
        'nomeRegional': null,
        'nomeGerente': null,
        'responsavelId': null,
        'agenteRelacionamento': null,
        'origensId': null,
        'quadrosId': null,
        'produtosId': null,
        'valorInicio': null,
        'valorFinal': null,
        'situacao': null,
        'dataInicial': null,
        'dataFinal': null
      },
      columns: [],
      columnsOpt: [
        { value: true, label: 'PROTOCOLO', key: 'protocolo' },
        { value: true, label: 'CPF/CNPJ', key: 'document' },
        { value: true, label: 'NOME', key: 'nome' },
        { value: true, label: 'PA', key: 'numeroPa' },
        { value: true, label: 'GERENTE SISBR', key: 'gerenteSisBR' },
        { value: true, label: 'AGENTE RELACIONAMENTO', key: 'gerenteRelacionamento' },
        { value: true, label: 'QUADRO', key: 'quadroNome' },
        { value: true, label: 'COLUNA', key: 'quadroColunaNome' },
        { value: false, label: 'ORIGEM', key: 'origem' },
        { value: false, label: 'RESPONSÁVEL', key: 'responsaveis' },
        { value: false, label: 'PRODUTO', key: 'produto' },
        { value: false, label: 'VALOR', key: 'valor' },
        { value: false, label: 'ABERTURA', key: 'abertura' },
        { value: false, label: 'FECHAMENTO', key: 'fechamento' },
        { value: false, label: 'SITUAÇÃO', key: 'situacao' },
        { value: false, label: 'MOTIVO', key: 'motivo' },
        { value: false, label: 'AGENDAMENTO', key: 'agendamento' },
        { value: false, label: 'DIAS ABERTO', key: 'diasEmAberto' },
        { value: false, label: 'CRIADO POR', key: 'criador' }
      ],
      selectedCard: null
    }
  },
  components: {
    AddConfirmation,
    ModalCard,
    NxDataGrid,
    NxDataGridColumn,
    NxDataGridItem,
    SidebarSearch
  },
  // mounted () {
  //   this.$eventHub.on('Filter', ({ filters }) => {
  //     this.filters = filters
  //     if (filters.dataInicial) {
  //       this.filters.dataInicial = this.moment(filters.dataInicial).format('YYYY-MM-DDT03:00:00.000')
  //     }
  //     if (filters.dataFinal) {
  //       this.filters.dataFinal = this.moment(filters.dataFinal).format('YYYY-MM-DDT03:00:00.000')
  //     }
  //     this.$refs.tableGrid.Clear()
  //     this.$nextTick(() => {
  //       this.onLoadAll()
  //     })
  //   })
  // },
  // beforeDestroy () {
  //   this.$eventHub.off('Filter')
  //   Tools.MinimizedASidebar()
  // },
  methods: {
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    onLoad () {
      this.setVisibleColumns()
      if (this.filters) {
        this.onLoadAll()
      } else {
        this.filters = {
          'document': null,
          'nome': null,
          'numeroPA': null,
          'nomeRegional': null,
          'gerenteId': null,
          'responsavelId': null,
          'gruposResponsaveisId': null,
          'origensId': null,
          'quadrosId': null,
          'produtosId': null,
          'valorInicio': null,
          'valorFinal': null,
          'situacao': null,
          'dataInicial': null,
          'dataFinal': null
        }
        this.onLoadAll()
        this.onLoadPAs()
      }
    },
    load (params) {
      return ReportCrmRepository.GetAll(this.filters, {
        params
      })
    },
    onLoadAll () {
      loading.push()
      ReportCrmRepository.GetAllCardsReport(this.filters, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch(this.onException)
    },
    onLoadPAs () {
      PARepository.GetAll()
        .then((response) => {
          let result = response.data.content
            .map((x) => ({'value': x.numero, 'text': x.descricao}))
          this.form.numeroPA.listOptions = result
        })
        .catch(this.onException)
    },
    showConfirmationModal () {
      this.$refs['confirmation-modal'].showModal()
    },
    onExportExcel () {
      const cookieName = 'exportInProgress'

      if (CookieUtils.isExportInProgress(cookieName)) {
        toast.warning('A exportação já está em execução ou foi interrompida recentemente. Tente novamente mais tarde.', 'Atenção!')
        return
      }

      CookieUtils.startExport(cookieName)
      loading.push()

      const columnsFilter = this.columnsOpt.reduce((acc, col) => {
        acc[col.key] = col.value
        return acc
      }, {})

      const payload = {
        filter: this.filters,
        columnsFilter
      }

      ReportCrmRepository.ExportAllCardsReport(payload)
        .then((response) => {
          loading.close()

          const fileStartName = this.moment().format('YYYYMMDDhhmm')
          const blob = new Blob([this.base64ToArrayBuffer(response.data)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const url = URL.createObjectURL(blob)

          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = fileStartName + '_RelatorioCrm.xlsx'
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)

          toast.success('Relatório exportado com sucesso!', 'Sucesso')
        })
        .catch(this.onException)
        .finally(() => {
          CookieUtils.completeExport(cookieName)
        })
    },

    base64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      var len = binaryString.length
      var bytes = new Uint8Array(len)
      for (var i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    },
    onFormatDocument (document) {
      return Tools.formatCpfCnpj(document, Tools.checkDocumentType(document))
    },
    setVisibleColumns () {
      this.columns = []
      for (let i = 0; i < this.columnsOpt.length; i++) {
        if (this.columnsOpt[i].value) {
          this.columns.push(this.columnsOpt[i].label)
        }
      }
    },
    openCard (cardId) {
      this.selectedCard = cardId
    },
    closeCard () {
      this.selectedCard = null
    },
    formatDateAndTime (rawDate) {
      const date = new Date(rawDate)
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')

      return `${day}/${month}/${year} às ${hours}:${minutes}`
    }
  }
}
</script>
<style>
.popover-header {
  background-color: #04a791;
  color: #eceff1
}
</style>



// WEBPACK FOOTER //
// src/views/private/reports/crm/reportcrm.vue